import {Container, Row} from "../../ui/grid";
import Title from "../../ui/title/Title";
import {GrzHelper} from "helper/GrzHelper";
import {useCallback, useEffect, useRef, useState} from "react";
import {NavLink, useParams} from "react-router-dom";
import styles from './SubscriptionInputs.module.scss'
import Layout from '../../layout'
import Phone2Svg from "../../../svg/Phone2Svg";
import CheckSvg from "../../../svg/CheckSvg";
import {PhoneHelper} from "../../../helper/PhoneHelper";
import RussianFlagSvg from "../../../svg/RussianFlagSvg";
import ForeinSvg from "../../../svg/ForeinSvg";
import Triangle2Svg from "../../../svg/Triangle2Svg";
import SubscriptionSvg from "../../../svg/SubscriptionSvg";
import { InfoType } from "../../../api/query/Info";

const SubscriptionInputsPage = () => {
  const {zone} = useParams();

  const [openCountryState, setOpenCountryState] = useState(false);
  const [rusFormatState, setRusFormatState] = useState(true);
  const [validGrzState, setValidGrzState] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [grzState, setGrzState] = useState('');
  const [grzStateWithoutSpace, setGrzStateWithoutSpace] = useState('');
  const [phoneValue, setPhoneValue] = useState('')
  const [errorPhoneValue, setErrorPhoneValue] = useState(true)
  const inputPhone = useRef<any>()
  const formatTouchedRef = useRef(false);
  const grzInputTouchedRef = useRef(false);
  let phoneValueW7 = phoneValue.match(/(\+7)(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/)
  let phoneValueW7Space = phoneValueW7 ? phoneValueW7[0] : ''
  let phoneValueW8 = phoneValue.match(/(8)(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/)
  let phoneValueW8Space = phoneValueW8 ? phoneValueW8[0] : ''

  const handleChangeGrz2 = (e: any) => {
    grzInputTouchedRef.current = true;
    const grzValue = e.target.value;
    if (rusFormatState) {
      const grzWithoutSpaces = GrzHelper.clearRus(grzValue);
      const grzArr = grzWithoutSpaces.match(/^([\s\S])([\s\S]{0,3})([\s\S]{0,2})([\s\S]{0,3})/);
      const grzFormatted = (Array.isArray(grzArr) ? grzArr : []).filter((v, i) => (i > 0 && v)).join(' ');
      setGrzState(grzFormatted);
    } else {
      setGrzState(grzValue);
    }
  }

  useEffect(() => {
    const withoutSpaces = grzState.replace(/\s/g, '');
    setGrzStateWithoutSpace(withoutSpaces);
    const hasValue = withoutSpaces !== '';
    const isValid = rusFormatState ? GrzHelper.testRus(grzState) : GrzHelper.testForeign(grzState);
    setValidGrzState(isValid);
    setErrorState(hasValue && !isValid);
  }, [grzState, rusFormatState]);

  const grzChangerMode = () => {
    formatTouchedRef.current = true;
    setRusFormatState((s) => (!s));
    setOpenCountryState(!openCountryState);
    setGrzState('');
    setErrorState(false)
  }

  const handleInfoLoaded = useCallback((info: InfoType) => {
    if (formatTouchedRef.current || grzInputTouchedRef.current) return;
    setRusFormatState(!info.result.internationalPlateFormat);
  }, []);

  const handleChangeValue = () => {
    const phone = PhoneHelper.handleChangeValue(inputPhone.current.value);
    setPhoneValue(phone.clear);
    inputPhone.current.value = phone.formatted;
  }

  useEffect(() => {
    // Телефон необязательный - если пустой, ошибки нет
    if (phoneValue === '') {
      setErrorPhoneValue(true);
    } else {
      setErrorPhoneValue(phoneValueW8Space.length === 11 || phoneValueW7Space.length === 12);
    }
    handleChangeValue();
  }, [phoneValue, phoneValueW8Space.length, phoneValueW7Space.length]);


  const canNext = () => {
    // Телефон необязательный - если пустой или правильной длины - ок
    const phoneValid = phoneValue === '' || phoneValueW8Space.length === 11 || phoneValueW7Space.length === 12;
    const hasGrzValue = grzStateWithoutSpace !== '';
    const grzValid = validGrzState && hasGrzValue && !errorState;
    return grzValid && phoneValid;
  }

  const searchParams = new URLSearchParams({
    grz: grzStateWithoutSpace ?? '',
    phone: phoneValue && phoneValue !== '' ? phoneValue : 'Не указан',
  });

  return (
    <Layout infoListener={handleInfoLoaded}>
      <section className={styles.section}>
        <Container>
          <div className={styles.img}>
            <SubscriptionSvg/>
          </div>
          <div className={styles.form}>
            <Title text="Введите номер автомобиля и телефон"/>
            <div className={styles.grz_input}>
              <Row center>
                <button onClick={() => {
                  setOpenCountryState(!openCountryState)
                }} className={styles.grz_input_btn}>
                  <Row center>
                    {rusFormatState ? <RussianFlagSvg/> : <ForeinSvg/>}
                    <Triangle2Svg/>
                  </Row>
                </button>
                <input
                  className={errorState ? styles.input_error : ''}
                  value={grzState}
                  onChange={handleChangeGrz2}
                  type="text"
                  placeholder={rusFormatState ? 'X 000 XX 00' : 'XXXXXXXX'}>
                </input>
              </Row>

              <button
                onClick={grzChangerMode}
                className={`${styles.form_input_btn_country} ${errorState ? styles.country_btn_w_error : ''} ${openCountryState ? styles.form_input_btn_country_active : ''} `}
              >
                {!rusFormatState ? <RussianFlagSvg/> : <ForeinSvg/>}
              </button>

            </div>

            <div className={`${styles.error} ${errorState ? '' : styles.hidden}`}>Некорректный формат номера
              автомобиля
            </div>

            <div className={styles.phone_input}>
              <Phone2Svg/>
              <input
                ref={inputPhone}
                onChange={handleChangeValue}
                type="text"
                placeholder="+7 (___) ___-__-__"
                className={errorPhoneValue ? "" : styles.input_error}
              >
              </input>
            </div>
            <div className={`${styles.error} ${errorPhoneValue ? styles.hidden : ""}`}>Некорректный формат номера
              телефона
            </div>

            <NavLink
              to={canNext() ? `/${zone}/subscription/list?${searchParams.toString()}` : ''}
              className={`${styles.form_btn} ${canNext() ? styles.form_btn__active : ''}`}
            >
              <CheckSvg/>
              <span>Подтвердить</span>
            </NavLink>
          </div>
        </Container>
      </section>
    </Layout>
  )
}

export default SubscriptionInputsPage;

